import React from 'react';
import './ourproduct.scss'

const OurProduct = () => {
	return (
		<div className="mainOurProduct">
			<div className="subOurProduct">
				<div className="OurProduct">
					<h2>Our Product</h2>
				</div>
				<div className="OurProductDescription">
					<p>At SuperCodingBits, we offer ready-to-use resources for building modern websites. You’ll find UI Elements to make your designs look clean and attractive, Cheatsheets to make coding easier to understand, and a Portfolio with real projects for ideas and inspiration. Everything is made to save you time, help you work faster, and create great results.</p>
					<p>Our products are made for developers of all skill levels. Whether you’re just starting or have years of experience, you can use our UI Elements, Cheatsheets, and Portfolio examples to speed up your work. With clean design and easy-to-follow code, we help you focus more on building and less on searching for solutions.</p>
				</div>
			</div>
		</div>
	);
};

export default OurProduct;